import { createApp } from 'vue'
import App from './App.vue'
import axios from './plugins/axios'
import toastr from './plugins/toastr'
import router from './router'
import store from './store'
import setupInterceptors from './plugins/axiosInterceptors'
import { createHead } from '@unhead/vue';

const head = createHead();
const app = createApp(App).use(router).use(store).use(head)

setupInterceptors()

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$toastr = toastr;
app.mount('#app')